import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import AuthenticateService from '../auth/AuthenticateService';
import AuthLayout from './AuthLayout';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [cpassword, setCPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [isLogging, setIsLogging] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const phoneNumber = sessionStorage.getItem('resetPhoneNumber');
  const navigate = useNavigate();
  const { http, setToken } = AuthenticateService();


  if(phoneNumber===null){
    navigate('/');
    sessionStorage.clear();

}


  const handlePasswordRequest = (e) => {
    e.preventDefault();
    if (password !== cpassword) {
      setError('Passwords do not match');
      setIsLogging(false);
      return;
    }
    setIsLogging(true);
    http.post('/users/reset-password', {
      phone_number: phoneNumber,
      otp_code:otp,
      password:password,
    })

      .then((res) => {
        // console.log(res);

        if (res.status === 200) {
          setError('');
          toast.success(res.data.message);
          // sessionStorage.setItem('resetPhoneNumber', phoneNumber);
          navigate('/');
          sessionStorage.clear();


        } else {
          setError(res.message);
          setIsLogging(false)
        }
      })
      .catch((error) => {

        // setError('Failed to resend ')users/resend-otp
        // console.log(error.response.data.message);
        toast.error('Resend Failed : ' + error.response.data.message);
        setIsLogging(false)

      });
  }

  return (
    <AuthLayout
      brandHeading="Set a new password"
      brandSubheading="Choose a strong password to keep your account safe and secure."
    >
      <ToastContainer />
      <div className="auth-heading">
        <h3 className="text-1000">Reset your password</h3>
        <p className="text-700">Enter the OTP sent to your phone and choose a new password</p>
      </div>

      {error && (
        <div className="alert alert-outline-danger d-flex align-items-center py-2 mb-3" role="alert">
          <span className="fas fa-circle-exclamation text-danger fs--1 me-2"></span>
          <p className="mb-0 flex-1 fs--1">{error}</p>
        </div>
      )}

      <form onSubmit={handlePasswordRequest}>
        <div className="auth-field">
          <label className="form-label" htmlFor="otp">Received OTP</label>
          <div className="form-icon-container">
            <input
              id="otp"
              className="form-control form-icon-input"
              type="number"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              placeholder="Enter OTP"
            />
            <span className="fas fa-key text-900 fs--1 form-icon"></span>
          </div>
        </div>

        <div className="auth-field">
          <label className="form-label" htmlFor="newPassword">New Password</label>
          <div className="form-icon-container position-relative">
            <input
              id="newPassword"
              className="form-control form-icon-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              type={showPassword ? 'text' : 'password'}
              placeholder="Type new password"
            />
            <span className="fas fa-lock text-900 fs--1 form-icon"></span>
            <button
              type="button"
              className="auth-toggle-visibility"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
            </button>
          </div>
        </div>

        <div className="auth-field">
          <label className="form-label" htmlFor="confirmNewPassword">Confirm New Password</label>
          <div className="form-icon-container">
            <input
              id="confirmNewPassword"
              className="form-control form-icon-input"
              value={cpassword}
              onChange={(e) => setCPassword(e.target.value)}
              type={showPassword ? 'text' : 'password'}
              placeholder="Confirm new password"
            />
            <span className="fas fa-lock text-900 fs--1 form-icon"></span>
          </div>
        </div>

        <button className="btn-auth-primary" type="submit" disabled={isLogging}>
          {isLogging ? (
            <>
              <Spinner animation="border" size="sm" /> Processing...
            </>
          ) : (
            <>Set Password <FontAwesomeIcon icon={faArrowRight} className="fs--1" /></>
          )}
        </button>
      </form>

      <div className="text-center mt-4">
        <Link className="fs--1 fw-bold" to="/">
          <span className="fas fa-arrow-left me-1"></span>Back to sign in
        </Link>
      </div>
    </AuthLayout>
  );
};

export default ResetPassword;
